import { useSelector } from 'react-redux'

import { getClientId, getPatientId } from '~/store/reducers/soap'

import { PatientMedicalSummaryRail } from '../../summary/PatientMedicalSummaryRail'
import { SoapPatientTile } from './SoapPatientTile'

import styles from './SoapPatientMedicalRecordRightRail.module.scss'

export const SoapPatientMedicalRecordRightRail = () => {
  const clientId = useSelector(getClientId) ?? ''
  const patientId = useSelector(getPatientId) ?? ''

  return (
    <div className={styles.rightRailContainer}>
      <div className={styles.patientDetailsHeader}>
        <SoapPatientTile />
      </div>
      <PatientMedicalSummaryRail clientId={clientId} patientId={patientId} />
    </div>
  )
}
